import Vue from 'vue';

Vue.component('business-fleet-title-with-content-component', {
    props: {
        formModalSelector: {
            type: String,
            required: false,
        },
    },

    data() {
        return {
            isModalOpen: false,
        };
    },

    created() {
        EventBus.$on('closeModal', () => {
            this.closeModal();
        });
    },

    mounted() {
        if (!this.formModalSelector) return;
        this.initFormModalOpen();
    },

    watch: {
        isModalOpen(newValue) {
            document.body.classList.toggle('no-scroll', newValue);
        },
    },

    methods: {
        initFormModalOpen() {
            setTimeout(() => {
                document
                    .querySelector(`a[href="#${this.formModalSelector}"]`)
                    .addEventListener('click', this.openFormModal);
            }, 1000);
        },

        closeModal() {
            this.isModalOpen = false;
        },

        openFormModal(e) {
            e.preventDefault();
            this.isModalOpen = !this.isModalOpen;
        },
    },
});
